<template>
  <div class="pcLeft">
    <el-menu
      default-active="1-4-1"
      class="el-menu-vertical-demo"
      :collapse="true"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-submenu
        v-for="item in componentsList"
        :key="item.index"
        :index="item.index"
      >
        <template slot="title">
          {{ item.title }}
        </template>
        <el-menu-item-group>
          <el-menu-item
            @click="addTemplate(_item)"
            :index="_item.index"
            v-for="_item in item.list"
            :key="_item.index"
            >{{ _item.title }}</el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      componentsList: [
        {
          title: "页头",
          index: "1",
          list: [
            {
              title: "header1",
              index: "1-1",
              type: "1",
              componentDescribe: "顶部导航栏",
            },
          ],
        },
        {
          title: "轮播图",
          index: "2",
          list: [
            {
              title: "banner1",
              index: "2-1",
              type: "1",
              componentDescribe: "轮播图",
            },
            {
              title: "banner2",
              index: "2-2",
              type: "5",
              componentDescribe: "导师轮播图",
            },
          ],
        },
        {
          title: "商品",
          index: "3",
          list: [
            {
              title: "goods1",
              index: "3-1",
              type: "2",
              componentDescribe: "商品",
            },
            {
              title: "goods2",
              index: "3-2",
              type: "2",
              componentDescribe: "商品",
            },
          ],
        },
        {
          title: "宣传",
          index: "4",
          list: [
            {
              title: "propaganda1",
              index: "4-1",
              type: "1",
              componentDescribe: "图文链接",
            },
            {
              title: "propaganda2",
              index: "4-2",
              type: "4",
              componentDescribe: "近期动态",
            },
          ],
        },
        {
          title: "模块",
          index: "7",
          list: [
            {
              title: "module1",
              index: "7-1",
              type: "4",
              componentDescribe: "企业新闻",
            },
            {
              title: "module2",
              index: "7-2",
              type: "1",
              componentDescribe: "公司信息",
            },
            {
              title: "module3",
              index: "7-3",
              type: "1",
              componentDescribe: "公司信息",
            },
          ],
        },
        {
          title: "页脚",
          index: "5",
          list: [
            {
              title: "footer1",
              index: "5-1",
              type: "1",
              componentDescribe: "底部导航栏",
            },
          ],
        },
        {
          title: "其他",
          index: "6",
          list: [
            {
              title: "other1",
              index: "6-1",
              type: "1",
              componentDescribe: "联系方式",
            },
            {
              title: "other2",
              index: "6-2",
              type: "1",
              componentDescribe: "合作伙伴",
            },
          ],
        },
      ],
    };
  },
  methods: {
    addTemplate(val) {
      this.$store.dispatch("design/addTemplate", val);
    },
  },
};
</script>
<style lang="less" scoped>
.pcLeft {
  width: 100px;
  height: 100%;
  background: #545c64;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid #eee;
  ::v-deep .el-menu--collapse .el-submenu__title span {
    display: none;
  }
  /*隐藏 > */
  ::v-deep .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
    display: none;
  }
  .el-menu--collapse {
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/components/pcLeft.vue